import moment from "moment";

const getUTCDate = (date: string) => {
  const convertedDate: string[] = date.split("-");
  const numberArray: number[] = convertedDate.map((str) => Number(str));
  if (numberArray.length === 3) {
    numberArray[1] = numberArray[1] - 1; // Date.UTC expects a value from 0-11
  }
  return new Date(Date.UTC(numberArray[0], numberArray[1], numberArray[2]));
};
const StringfyDate = (date: string | null, format?: string) => {
  if (!date || date === null) return "";
  const stringfiedDate = moment(date)
    .locale("en")
    .format(format ?? DATE_FORMAT.DASH_YYYMMDD);
  return stringfiedDate;
};

const DATE_FORMAT = {
  DASH_YYYMMDD: "YYYY-MM-DD",
  SLASH_DDMMYYYY: "DD/MM/YYYY",
  COMMA_MMMDYYYY: "MMM D, YYYY",
};
export { getUTCDate, StringfyDate, DATE_FORMAT };
